import { ICustomComponentConfig, IDashboardComponent } from "../../../types";
import { IParentSize, ISelectedNode, IState } from "../../../../../types";
import { useSelector } from "react-redux";
import HeatVariables from "./heatVaraibles/heatVariables";
import { DashboardSchemaType } from "../../../../interruptions/types";
import { ReactElement } from "react";

interface IProps {
  component: IDashboardComponent<ICustomComponentConfig>;
  parentSize: IParentSize;
  schemas: Record<DashboardSchemaType, any>;
}

const CustomWidgetWrapper = ({ component, parentSize, schemas }: IProps): ReactElement => {
  const selectedNode = useSelector<IState, ISelectedNode>(state => state.selectedNode);

  if (selectedNode.code === "EAF") {

    return (
      <div className="p-1">
        <HeatVariables parentSize={parentSize} selectedNode={selectedNode} component={component} schemas={schemas} />
      </div>
    );
  }

  return (
    <div style={{ ...parentSize, background: "red" }} />
  );
};

export default CustomWidgetWrapper;